import {
  createErrorType,
  createLoadingType,
  createSubmitType,
  createSuccessType,
} from '../actionHelpers';

const FINGERPRINT_SCOPE = 'FINGERPRINT';
export const SET_FINGERPRINT = createSubmitType(FINGERPRINT_SCOPE);
export const SET_FINGERPRINT_SUCCESS = createSuccessType(FINGERPRINT_SCOPE);
export const SET_FINGERPRINT_ERROR = createErrorType(FINGERPRINT_SCOPE);
export const SET_FINGERPRINT_LOADING = createLoadingType(FINGERPRINT_SCOPE);

//  post tracking details
const POST_TRACKING_DETAILS_SCOPE = 'POST_TRACKING_DETAILS';
export const POST_TRACKING_DETAILS = createSubmitType(
  POST_TRACKING_DETAILS_SCOPE,
);
export const POST_TRACKING_DETAILS_SUCCESS = createSuccessType(
  POST_TRACKING_DETAILS_SCOPE,
);
export const POST_TRACKING_DETAILS_ERROR = createErrorType(
  POST_TRACKING_DETAILS_SCOPE,
);
export const POST_TRACKING_DETAILS_LOADING = createLoadingType(
  POST_TRACKING_DETAILS_SCOPE,
);
